// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2escN","content":"ManualTimeModal_content__2iNXh"};